import { render, staticRenderFns } from "./CreditGift.vue?vue&type=template&id=766d38f1"
import script from "./CreditGift.vue?vue&type=script&lang=js"
export * from "./CreditGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports